import { webToCatchFaceConnect } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/lace/webToCatchFaceConnect'
import { webKnots } from 'src/features/atoms/glove/drawer/common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint } from './parts/sideParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const hWeb = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // 横上パーツ
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // 横下パーツ
  await middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1, printLeatherTypeValue)

  // 縦パーツ
  const drawPath = () => {
    ctx.beginPath()
    ctx.moveTo(627, 117) //左上
    ctx.quadraticCurveTo(607, 176, 571, 220) //左下
    ctx.quadraticCurveTo(591, 240, 607, 280) //右下
    ctx.quadraticCurveTo(658, 233, 672, 184) //右上
    ctx.quadraticCurveTo(650, 141, 627, 115) //左上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawPath, webColor2)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // // 縦向き＿左＿外側
  ctx.moveTo(629, 123) // 上
  ctx.quadraticCurveTo(611, 177, 576, 220) // 下
  // // 縦向き＿左＿内側
  ctx.moveTo(632, 127) // 上
  ctx.quadraticCurveTo(615, 179, 579, 224) // 下
  // // 縦向き＿右＿内側
  ctx.moveTo(665, 178) // 上
  ctx.quadraticCurveTo(641, 239, 605, 267) // 下
  // // 縦向き＿右＿外側
  ctx.moveTo(668, 183) // 上
  ctx.quadraticCurveTo(647, 239, 607, 272) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  ctx.fillStyle = webColor
  // stitchここまで

  // laceここから
  webToCatchFaceConnect(ctx, laceColor, -35, 15)
  webKnots(ctx, laceColor, 25, -60) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -25, 25) // 捕球面寄りのウェブ結び目
}

export const hJointWeb = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'

  // 横上パーツ
  await topSidePartOfWebWithJoint(ctx, webColor, webColor2, laceColor, stitchColor, printLeatherTypeValue)
  // 横下パーツ
  await middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -17, 18, 1, 1, printLeatherTypeValue)

  // 縦パーツ
  const drawPath = () => {
    ctx.beginPath()
    ctx.moveTo(610, 160) //左上
    ctx.quadraticCurveTo(607, 176, 563, 226) //左下
    ctx.quadraticCurveTo(585, 250, 599, 283) //右下
    ctx.quadraticCurveTo(633, 254, 648, 225) //右上
    ctx.quadraticCurveTo(635, 186, 610, 160) //左上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawPath, webColor2 || webColor)
  ctx.fillStyle = webColor

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // // 縦向き＿左＿外側
  ctx.moveTo(612, 167) // 上
  ctx.quadraticCurveTo(601, 194, 576, 220) // 下
  // // // 縦向き＿左＿内側
  ctx.moveTo(614, 170) // 上
  ctx.quadraticCurveTo(605, 195, 580, 222) // 下
  // // // 縦向き＿右＿内側
  ctx.moveTo(642, 220) // 上
  ctx.quadraticCurveTo(629, 247, 606, 269) // 下
  // // // 縦向き＿右＿外側
  ctx.moveTo(644, 224) // 上
  ctx.quadraticCurveTo(633, 249, 608, 273) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webToCatchFaceConnect(ctx, laceColor, -35, 15)
  webKnots(ctx, laceColor, 5, -15) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -30, 30) // 捕球面寄りのウェブ結び目
}
